import { Link } from "react-router-dom";
import { ArrowRight, Warehouse, Broadcast, Truck, Gear, ChartLineUp, ShieldCheck } from "@phosphor-icons/react";
import Layout, { PageHeader } from "../components/Layout";
import SEO from "../components/SEO";
import { Reveal, Stagger, StaggerItem } from "../components/motion";
import { IMAGES } from "../data/images";

const services = [
  { i: Warehouse, t: "Managed Warehouse & Factory Operations", d: "We run inbound, storage, labour and dispatch as one accountable operation." },
  { i: Broadcast, t: "Operations Instrumented by Eazymuv OS", d: "A connected operating view so plans and floor reality stay in sync." },
  { i: Truck, t: "Managed Logistics & Dispatch", d: "Reliable movement of goods from your dock to your customers." },
  { i: Gear, t: "Process Design & Standardisation", d: "Codify operating rhythms that hold up under real-world volatility." },
  { i: ChartLineUp, t: "Performance & SLA Management", d: "Measured execution against the outcomes that matter to you." },
  { i: ShieldCheck, t: "Compliance & Temperature Discipline", d: "Cold-chain and traceability rigour for food, frozen and pharma-adjacent goods." },
];

export default function WhatWeDo() {
  return (
    <Layout>
      <SEO title="What We Do" description="Eazymuv runs supply chain execution across factory, warehouse and logistics — one accountable partner, instrumented by Eazymuv OS." />
      <PageHeader eyebrow="What We Do" title={<>We run the work others only plan</>} subtitle="Eazymuv takes ownership of on-the-ground execution across the plant, the warehouse and logistics — with one accountable line and one operating view." image={IMAGES.forkliftYellow} imageAlt="Yellow forklift in cold storage warehouse" />
      <section className="max-w-[1600px] mx-auto px-5 md:px-8 py-20 md:py-28">
        <Stagger className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border border-ez-text">
          {services.map((s, i) => (
            <StaggerItem key={i} className="group border-b border-r border-ez-border p-8 hover:bg-ez-yellow transition-colors">
              <s.i size={30} weight="duotone" className="text-ez-text mb-6" />
              <div className="font-display text-xl uppercase tracking-tight leading-tight">{s.t}</div>
              <p className="mt-3 text-sm text-ez-text/70">{s.d}</p>
            </StaggerItem>
          ))}
        </Stagger>
      </section>
      <section className="bg-os-bg text-white grain relative border-y border-white/10">
        <div className="absolute inset-0 grid-bg-dark opacity-30" />
        <div className="relative max-w-[1600px] mx-auto px-5 md:px-8 py-20 md:py-28 text-center flex flex-col items-center">
          <h2 className="font-display text-3xl md:text-5xl uppercase tracking-tighter max-w-3xl leading-tight">One partner. One accountability. One operating view.</h2>
          <Link to="/contact" data-testid="whatwedo-cta" className="mt-8 inline-flex items-center gap-2 bg-ez-yellow text-ez-text px-7 py-4 font-semibold hover:bg-white transition-colors">
            Discuss Your Operations <ArrowRight size={18} weight="bold" />
          </Link>
        </div>
      </section>
    </Layout>
  );
}
